<template>
  <div>
    <v-autocomplete
      v-model="selectedAuthor"
      :loading="loading"
      :items="authors"
      :search-input.sync="search"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      outlined
      dense
      clearable
      hide-no-data
      hide-selected
      @change="handleAuthorSelected"
    >
      <template #item="{ item }">
        <v-list-item-content>
          <v-list-item-title v-text="item.name" />
          <v-list-item-subtitle
            v-if="item.bio"
            class="text-truncate"
          >
            {{ item.bio }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
      <template #no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('common.noResults') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import AuthorQueries from '@/graphql/AuthorQueries';

export default {
  name: 'AuthorSearch',
  props: {
    label: {
      type: String,
      default: 'Search Authors'
    },
    value: {
      type: Object,
      default: () => null
    }
  },
  emits: ['input', 'author-selected'],
  data() {
    return {
      search: '',
      loading: false,
      authors: [],
      selectedAuthor: this.value,
      searchAuthorsDebounced: debounce(this.searchAuthors, 300)
    };
  },
  watch: {
    search(val) {
      if (val && val.length > 2) {
        this.loading = true;
        this.searchAuthorsDebounced(val);
      }
    },
    value(val) {
      if (val !== this.selectedAuthor) {
        this.selectedAuthor = val;
      }
    }
  },
  methods: {
    async searchAuthors(query) {
      try {
        const result = await this.$apollo.query({
          query: AuthorQueries.getAuthors,
          variables: {
            first: 10,
            name: query
          }
        });
        
        this.authors = result.data.authors.edges.map(edge => edge.node);
      } catch (error) {
        console.error('Error searching authors:', error);
        this.$store.dispatch('snackbar/showSnackbar', {
          text: this.$t('admin.authors.searchError'),
          color: 'error'
        });
      } finally {
        this.loading = false;
      }
    },
    
    handleAuthorSelected() {
      if (this.selectedAuthor) {
        this.$emit('input', this.selectedAuthor);
        this.$emit('author-selected', {
          id: this.selectedAuthor.id,
          _id: this.selectedAuthor._id,
          name: this.selectedAuthor.name,
          bio: this.selectedAuthor.bio
        });
      } else {
        this.$emit('input', null);
        this.$emit('author-selected', null);
      }
    }
  }
};
</script>
